import { DatePipe } from '@angular/common';
import { EnvironmentProviders, inject, makeEnvironmentProviders, Provider, provideEnvironmentInitializer } from '@angular/core';

import { BaasI18n } from '@lvflanders/bar';

import didoDocumentenControlTranslations from './dido-documenten-control.i18n';
import { DIDO_DOCUMENTEN_CONTROL_SHARED_I18N } from './dido-documenten-control-shared.i18n';
import { DeleteTooltipPipe } from './pipes/delete-tooltip.pipe';
import { DidoDocumentenService } from './services/dido-documenten.service';
import { DidoGalleryService } from './services/dido-gallery.service';

export function provideDidoControls() {
    const providers: Array<Provider | EnvironmentProviders> = [
        DidoDocumentenService,
        DatePipe,
        DidoGalleryService,
        DeleteTooltipPipe,
        provideEnvironmentInitializer(() => {
                const baasI18n = inject(BaasI18n);
                baasI18n.addTranslations('DOMAIN_DIDO', didoDocumentenControlTranslations);
                baasI18n.addTranslations('SHARED', DIDO_DOCUMENTEN_CONTROL_SHARED_I18N);
            })
    ];
    return makeEnvironmentProviders(providers);
}
